export function allFalsy(object: Object): boolean {
  return Object.values(object).every((v) =>
    v && typeof v === "object" ? allFalsy(v) : v === 0 || v === null
  );
}
